<template>
  <aha-dropdown-v2 class="h-full flex items-center">
    <aha-dropdown-trigger-v2 :disabled="isDefaultCanvasBlocks || loading" class="h-full flex items-center">
      <button
        class="improve-writing-dropdown-trigger ml-3 h-full"
        :class="{'disabled': isDefaultCanvasBlocks, 'button-loading': loading }"
      >
        <aha-icon name="sparkles-outline" class="mr-1" />
        <span>{{ $i18nPresenter.t('Improve') }}</span>
        <aha-spinner
          v-if="loading"
          size="xs"
        />
        <aha-icon
          v-else
          name="down"
        />
      </button>
    </aha-dropdown-trigger-v2>

    <aha-dropdown-menu :width="'250px'">
      <ImproveWritingButton
        v-for="(setting, settingIndex) in generalSettings"
        :key="'general-' + settingIndex"
        :setting="setting"
        :isDefaultCanvasBlocks="isDefaultCanvasBlocks"
        @onImproveWritingButtonClicked="handleImproveWritingButtonClick('general', $event, settingIndex)"
        v-aha-emit-action="{ user_input: setting.label }"
      />
      <aha-dropdown-divider />
      <ImproveWritingButton
        v-for="(setting, settingIndex) in toneSettings"
        :key="'tone-' + settingIndex"
        :setting="setting"
        :isDefaultCanvasBlocks="isDefaultCanvasBlocks"
        @onImproveWritingButtonClicked="handleImproveWritingButtonClick('tone', $event, settingIndex)"
        v-aha-emit-action="{ user_input: setting.label }"
      />
      <aha-dropdown-divider />
      <ImproveWritingButton
        v-for="(setting, settingIndex) in complexitySettings"
        :key="'complexity-' + settingIndex"
        :setting="setting"
        :isDefaultCanvasBlocks="isDefaultCanvasBlocks"
        @onImproveWritingButtonClicked="handleImproveWritingButtonClick('complexity', $event, settingIndex)"
        v-aha-emit-action="{ user_input: setting.label }"
      />
      <aha-dropdown-divider />
      <ImproveWritingButton
        v-for="(setting, settingIndex) in lengthSettings"
        :key="'length-' + settingIndex"
        :setting="setting"
        :isDefaultCanvasBlocks="isDefaultCanvasBlocks"
        @onImproveWritingButtonClicked="handleImproveWritingButtonClick('length', $event, settingIndex)"
        v-aha-emit-action="{ user_input: setting.label }"
      />
    </aha-dropdown-menu>
  </aha-dropdown-v2>
</template>
<script>
import AIAutoImproveWriting
  from '@/components-v2/presentation-editor/side-right/right-nav/AIAutoImproveWriting.vue'
import ImproveWritingButton from './ImproveWritingButton.vue'

export default {
  name: 'DropdownMenu',
  components: {
    ImproveWritingButton,
  },

  extends: AIAutoImproveWriting,
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    async  handleImproveWritingButtonClick(mode, value, settingIndex) {
      if (this.loading) return
      this.loading = true
      await this.improveSlideContent(mode, value, settingIndex)
      this.loading = false
    },
  },
}
</script>
<style lang="scss" scoped>
.button-loading{
  cursor: pointer;
  pointer-events: none;
}
.improve-writing-dropdown-trigger{
  display: flex;
  color : #282E3E;
  align-items: center;
  justify-content: center;
  gap: 4px;
  height: 100%;

  &:hover{
    color: #6C6C6C;
    svg{
      path{
        fill: #6C6C6C;
      }
    }
  }
  // when press
  &:active{
    color: #282E3E;
    svg{
      path{
        fill: #282E3E;
      }
    }
  }
  &::v-deep{
    .aha-spinner{
      width:10px!important;
      height:10px!important;
    }
  }
  &:disabled{
    color :#9D9D9D;
    cursor: not-allowed;
    opacity: 0.5;
    pointer-events: none;
    &:hover{
      color: #9D9D9D;
    }
  }

}
</style>
